module.exports = __webpack_public_path__ + "img/27-r.a4b4e162.png";